import { render } from 'preact';
import { App } from './App';
import './styles/fonts.css';
import './styles/tokens.css';
import './styles/app.css';
import './styles/reader.css';

const root = document.getElementById('app');
if (!root) {
	throw new Error('Root element not found');
}

render(<App />, root);
